import React from 'react'
import { DropdownInput, MultiSelectDropdown } from '../../Inputs';
import { dropDownListObject, multiSelectOption } from '../../Utils/contructObject';
import { getCommonParams } from '../../Utils/helper';
import { useGetPartyQuery } from '../../redux/ErpServices/PartyMasterServices';

const PartyDropdown = ({ multiSelect = true, withoutLabel = true, readOnly, name, selected, setSelected, required }) => {
    const { token, ...params } = getCommonParams();
    const { data: partyList } = useGetPartyQuery({ params });
    return (
        <>
            {withoutLabel ?
                <select required={required} value={selected} onChange={(e) => setSelected(e.target.value)} className='w-full table-data-input'>
                    <option value="">Select</option>
                    {(partyList ? partyList.data : []).map(item =>
                        <option key={item.id} value={item.id}>{item.aliasName}</option>
                    )}
                </select>
                :
                <>
                    {multiSelect ?
                        <MultiSelectDropdown required={required} readOnly={readOnly} name={name} selected={selected} setSelected={setSelected}
                            options={multiSelectOption(partyList ? partyList.data : [], "aliasName", "id")} />
                        :
                        <DropdownInput required={required} readOnly={readOnly} name={name} value={selected} setValue={setSelected}
                            options={dropDownListObject(partyList ? partyList.data : [], "aliasName", "id")} />
                    }
                </>
            }
        </>
    )
}

export default PartyDropdown
